import { useContext } from 'react';
import type { StageAtoms } from './types/stage-atoms';
import { StageAtomsContext } from './context';
export function useStageAtoms(): StageAtoms {
  const atoms = useContext(StageAtomsContext);
  if (!atoms) {
    throw new Error('useStageAtoms() called outside <StageScope>.\n' + 'Every stage instance must be wrapped in <StageScope config={...}>.');
  }
  return atoms;
}